import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportSection from "./AbstractPeriodReportSection.js";
import AgedAccountsSummary from "../AgedAccountsSummary.js";

/**
 * Section used to render the aged accounts receivables chart associated to a period report.
 *
 * @param {AgedAccountsSummary} agedAccountsSummary - The summary model containing the summary
 * groups and total.
 */
export default class AgedAccountsReceivablesSection extends AbstractPeriodReportSection {
	constructor({ agedAccountsSummary } = {}) {
		super(...arguments);

		this._summary = agedAccountsSummary;
	}

	getTitle() {
		return _("Aged Accounts Receivables");
	}

	getSummary() {
		return this._summary;
	}

	accept(visitor) {
		return visitor.visitAgedAccountsReceivablesSection(this);
	}

	isEnabled() {
		return super.isEnabled() && this.hasAgedAccountsSummary();
	}

	hasAgedAccountsSummary() {
		return this._summary && !this._summary.isEmpty();
	}

	static getType() {
		return "AgedAccountsReceivablesSection";
	}

	static getId() {
		return "aged-accounts-receivables";
	}

	static isAgedAccountsSection() {
		return true;
	}

	static transformMaterializationData(data, context) {
		data.agedAccountsSummary = AgedAccountsSummary.materialize(
			data.agedAccountsSummary,
			context,
		);
	}
}
